import $ from 'jquery';

export default{
     addScroll
} 

export function addScroll() {  
    $('body').css('overflow-x', 'auto');
    $('body').css('overflow-y', 'auto');    
    $('body').css('padding-right', '0');
    $('body').css('margin-right', '0');    
    $('.row').css('margin-right', '0');
    $('.row').css('margin-left', '0');
  }


// WEBPACK FOOTER //
// ./src/components/utils/utils.js